var map = {
	"./WR Blob 1.mp3": "3346",
	"./WR Blob 10.mp3": "3714",
	"./WR Blob 11.mp3": "5d62",
	"./WR Blob 12.mp3": "6fd2",
	"./WR Blob 13.mp3": "56e8",
	"./WR Blob 14.mp3": "ea83",
	"./WR Blob 15.mp3": "e56f",
	"./WR Blob 16.mp3": "c3a7",
	"./WR Blob 2.mp3": "0752",
	"./WR Blob 3.mp3": "9e8a",
	"./WR Blob 4.mp3": "8dc0",
	"./WR Blob 5.mp3": "7089",
	"./WR Blob 6.mp3": "f7ba",
	"./WR Blob 7.mp3": "6355",
	"./WR Blob 8.mp3": "f051",
	"./WR Blob 9.mp3": "5703"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b73e";